const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation} from "react-i18next";

//Import Designs
import {FormControl, Grid, Typography, Button, TextField, FormLabel, FormControlLabel, RadioGroup, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Chip, MenuItem, Select} from '@material-ui/core';

import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import CheckIcon from '@material-ui/icons/Check';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import FavoriteIcon from "@material-ui/icons/Favorite";

import {loadStripe} from '@stripe/stripe-js';
import StripeButton from './StripeButton.jsx';
import { CardElement } from '@stripe/react-stripe-js';

import { PayPalButton } from "react-paypal-button-v2";

import { PaystackButton } from 'react-paystack';
import ReCAPTCHA from "react-google-recaptcha";

class BuyvotesButton extends Component{
    constructor(props){
        super(props); 
        let allcatoption = this.props.short.allcatoption;
        let amount = 0;
        let votes_count = 0;
        let cost_single_vote = 0;
        let min_vote = 0;
        let fixed_tiers = false;

        if(allcatoption.wpvc_category_tiered_payment_settings == 'on' ){
            votes_count = allcatoption.wpvc_category_amountvotes_range[0].from;
            amount = allcatoption.wpvc_category_amountvotes_range[0].value * votes_count;
            min_vote = votes_count;
            if(allcatoption.wpvc_category_amountvotes_range[0].from == allcatoption.wpvc_category_amountvotes_range[0].to){
                fixed_tiers = true;
            }
        }else{
            amount = allcatoption.wpvc_category_amountvotes;
            votes_count = allcatoption.wpvc_category_amountvotesfor;
            min_vote = votes_count;
        }
        cost_single_vote = amount / votes_count;

        this.state = {vote_font:'',vote_btn:'', open : false, cost_for_one_vote: cost_single_vote, cost: amount, no_of_votes: votes_count, payment_gateway : '', payment_details : '', stripe_secret: '', min_vote : min_vote, fixed_tiers: fixed_tiers, show_min_vote_alert: false, show_popup: false, popup_title:null, popup_content:null, popup_extra:null, popbg_color:null, popbg_icon:null, show_index:null, show_recaptcha: 0, captcha_verfied: false };
    }
    
    handleClickOpen = () => {

        const { vote_enable_recaptcha_voting } = this.props.settings.common;
        
        if(vote_enable_recaptcha_voting == "on" && this.state.captcha_verfied == false){
            this.setState({show_recaptcha: 1});
        }else{
            this.setState({ open : true });
        }

    };
    
    handleClose = () => {
        this.setState({ open : false, captcha_verfied: false });
    };

    handleCaptchaClose = (event) => {   
        this.setState({
            show_recaptcha: 0
        });      
    }

    componentDidMount = () =>{
        this.setState({
            vote_font:this.props.settings.color.votes_button_font_color,
            vote_btn:this.props.settings.color.votes_button_bgcolor,
        });
    }

    toggleHovertwo = (value,val,name) => () => {
        this.setState({vote_font : value,vote_btn:val});
    }

    toggleleavetwo = (value,val,name) => () => {
        this.setState({vote_font : value,vote_btn:val});
    }

    updatePaymentGateway = (event) => {
        this.setState({payment_gateway : event.target.value});
        if(this.state.stripe_secret == ''){
            this.getStripeKey();
        }
    }

    handleValueChange = () => (event) => {
        this.setState({show_min_vote_alert : false })
        const { allcatoption } = this.props.short;
        if((this.props.short.allcatoption.wpvc_category_selvotes_settings != 'on' || this.props.short.allcatoption.wpvc_category_tiered_payment_settings != 'on')){
            if(parseInt(event.target.value) < parseInt(this.state.min_vote)){
                this.setState({show_min_vote_alert : true })
                return
            }else if(event.target.value == '' ){
                this.setState({show_min_vote_alert : true })
            }
        }
        let amount = 0;
        if(allcatoption.wpvc_category_tiered_payment_settings == 'on'){
            let cost_for_one_vote = this.state.cost_for_one_vote;
            allcatoption.wpvc_category_amountvotes_range.map((row) => {
                if(parseInt(event.target.value) >= parseInt(row.from) && parseInt(event.target.value) <=  parseInt(row.to)){
                    cost_for_one_vote = row.value;
                    return false;
                }

                if (parseInt(event.target.value) >= parseInt(row.from)) {
                    cost_for_one_vote = parseFloat(row.value);
                }
            });
            amount = cost_for_one_vote * event.target.value;
        }else{
            amount = this.state.cost_for_one_vote * event.target.value;
        }
                
        this.setState({no_of_votes : event.target.value, cost: amount.toFixed(2)})
        if(this.state.cost > 1){
            this.getStripeKey();
        }
    }

    getStripeKey(){
        
        let dataURL  = this.props.SITE_URL + "/wp-json/wpvc-voting/v1/wpvcgetstripesecret";
          
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({cost:this.state.cost}),
            headers: { 'Content-Type': 'application/json' }
        };
        
        fetch(dataURL, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                //After Data Loading Send to Get Data to display the data respectively
                this.setState({ stripe_secret: result.clientSecret });
                return result
            },
            (error) => {
              console.log('something went wrong: ', error);
            }
        );
    }


    handleStripeSubmit = (elements, stripe) => async (event) => {
        event.preventDefault();
        // const {stripe, elements} = this.props;
        if (!stripe || !elements) {
            return;
        }
        const card = elements.getElement(CardElement);

        const payload = await stripe.confirmCardPayment(this.state.stripe_secret, {
            payment_method: {
            card: card
            }
        });
        
        if (payload.error) {
            let error_msg = payload.error.message.replace(":","-");
            this.setState({
                show_popup : 1,
                popup_title:"Transaction Failed",
                popup_content: error_msg,
                popbg_color:'#e67e22',
                popbg_icon:"already",
                show_index:this.props.indexpost
            });
        } else {
        let payment_details = { 'gateway' : 'stripe', 'response' : payload.paymentIntent, 'cost': this.state.cost, 'vote_count' : this.state.no_of_votes, 'index' : this.props.indexpost, 'settings' : this.props.settings.contest, 'term' : this.props.short.id};
        this.props.buyvotesPayment(this.props.SITE_URL, this.props.singlepost.id, payment_details);
        //   alert('Voted Successfully');

            this.setState({show_popup : 1,
                popup_title:"voted_sucess",
                popup_content:"you_voted",
                popbg_color:'#29b664',
                popbg_icon:"sucess",
                show_index:this.props.indexpost
            })

        }

    };

    handlePaystackSuccessAction = (reference) => {
        if(reference.status === "success"){
            let payment_details = { 'gateway' : this.state.payment_gateway, 'response' : reference, 'cost': this.state.cost, 'vote_count' : this.state.no_of_votes, 'index' : this.props.indexpost, 'settings' : this.props.settings.contest, 'term' : this.props.short.id};
            this.props.buyvotesPayment(this.props.SITE_URL, this.props.singlepost.id, payment_details);
            // alert('Voted Successfully');
            this.setState({show_popup : 1,
                popup_title:"voted_sucess",
                popup_content:"you_voted",
                popbg_color:'#29b664',
                popbg_icon:"sucess",
                show_index:this.props.indexpost
            })
        }else{
            this.setState({show_popup : 1,
                popup_title:"Transaction Failed",
                popup_content:"Transaction failed. Try again or contact support.",
                popbg_color:'#e67e22',
                popbg_icon:"already",
                show_index:this.props.indexpost
            })
        }
    };

    handlePaystackCloseAction = () => {
        this.setState({
            show_popup : 1,
            popup_title:"Transaction Cancelled", 
            popup_content:'You have cancelled the payment.',
            popbg_color:'#e67e22',
            popbg_icon:"already",
            show_index:this.props.indexpost
        })
    }

    componentWillReceiveProps(nextProps) {
        if(typeof nextProps.update_vote_count !== "undefined"){
            this.setState({open: false});
            let post_index = nextProps.update_vote_count.post_index;
            let voting_count = nextProps.update_vote_count.voting_count;
            this.props.frontimmutable('posts',post_index,'votes_count',voting_count);
        }
    }

    handlemodalclose = (event) => {   
        this.setState({
            show_popup: false,
            popup_title:null,
            popup_content:null,
            popbg_color:null,
            popbg_icon:null,
            show_index:null
        });      
    }

    onCaptchaClick = (value) => {
        if(value){
            this.props.verifyCaptcha(this.props.SITE_URL, value).then(
                val => {
                    this.setState({ captcha_verfied : val.verified, show_recaptcha: val.verified ? 0 : 1 });
                    if(val.verified){
                        this.setState({ open : true });
                    }
                }
            ); 
        }
    }

    render(){
        const { t } = this.props; 
        // console.log(this.props);
        const {votes_button_font_size,votes_button_font_color,votes_button_font_color_hover,votes_button_bgcolor,votes_button_bgcolor_hover} = this.props.settings.color;
        
        const { vote_recapatcha_key } = this.props.settings.common;
        const { allcatoption } = this.props.short;
        const { wpvc_buyvotes_settings } = this.props.settings;
        const paypalClientID = wpvc_buyvotes_settings.ow_buyvotes_mode == '0' ? this.props.WPVC_BUYVOTES_PAYPAL_SANDBOX : this.props.ow_buyvotes_paypal_id;
        //Paystack Configuration
        const paystackconfig = {
            reference: (new Date()).getTime(),
            email: "user@example.com",
            amount: this.state.cost * 100,
            publicKey: wpvc_buyvotes_settings.ow_buy_paystack_publickey,
            // currency: wpvc_buyvotes_settings.ow_buyvotes_currency
        };

        const componentProps = {
            ...paystackconfig,
            text: t('buyvotes_paywith_paystack'),
            onSuccess: (reference) => this.handlePaystackSuccessAction(reference),
            onClose: this.handlePaystackCloseAction,
        };
        
        const stripePromise = loadStripe(this.props.settings.wpvc_buyvotes_settings.ow_buy_stripe_publishkey);
        
        const ranges = allcatoption.wpvc_category_amountvotes_range ? allcatoption.wpvc_category_amountvotes_range : [];
        const ranges_dropdown = ranges.map((row) =>
            <MenuItem value={row.from}>{row.from}</MenuItem>
        );

        return (
            
            <div className="wpvc_contestant_vote_class_buyvotes">
                <Button variant="contained" className="wpvc_voting_btns" color="primary" startIcon={<FavoriteIcon />} 
                    style={{'font-size':votes_button_font_size+'px','color':this.state.vote_font,'background':this.state.vote_btn}}
                    onMouseOver={this.toggleHovertwo(votes_button_font_color_hover,votes_button_bgcolor_hover,'vote_btn')}
                    onMouseLeave={this.toggleleavetwo(votes_button_font_color,votes_button_bgcolor,'vote_btn')}
                    onClick={this.handleClickOpen}
                >
                {t("buyvotes_button")}
                </Button>

                <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title" fullWidth>
                    <DialogTitle id="form-dialog-title">{t("buyvotes_payment_gateway")}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                        {t("buyvotes_min_spend")}
                        </DialogContentText>
                        { allcatoption.wpvc_category_selvotes_settings == 'on' && !this.state.fixed_tiers &&
                        <Grid container className="wpvc_form_grid">
                            <Grid item xs={4} className="wpvc_label"><Typography paragraph="true">{t("buyvotes_category_votes")}</Typography></Grid>
                            <Grid item xs={8}>
                                <FormControl className="wpvc_form_control">
                                    <TextField autoFocus name="buy_votes_text" type="number" value={this.state.no_of_votes} fullWidth onChange={this.handleValueChange()} />
                                </FormControl>
                            </Grid>    
                        </Grid>
                        }
                        { this.state.fixed_tiers &&
                        <Grid container className="wpvc_form_grid">
                            <Grid item xs={4} className="wpvc_label"><Typography paragraph="true">{t("buyvotes_category_votes")}</Typography></Grid>
                            <Grid item xs={8}>
                                <FormControl className="wpvc_form_control">
                                    <Select fullWidth name="buy_votes_text" value={this.state.no_of_votes} onChange={this.handleValueChange()} style={{minWidth: 120}} >
                                    {(ranges_dropdown)?ranges_dropdown:<MenuItem value="">{t("select")}</MenuItem>}
                                    </Select>
                                </FormControl>
                            </Grid>    
                        </Grid>
                        }

                        {((this.props.short.allcatoption.wpvc_category_selvotes_settings != 'on' || this.props.short.allcatoption.wpvc_category_tiered_payment_settings != 'on')) && this.state.show_min_vote_alert &&
                             <Chip
                             label={ t("minimum") + ' ' + allcatoption.wpvc_category_amountvotes + ' ' + t("buyvotes_category_votes")}
                             color="secondary"
                             variant="outlined"
                           />
                        }

                        { (allcatoption.wpvc_category_selvotes_settings != 'on' || allcatoption.wpvc_category_tiered_payment_settings != 'on') &&
                        <DialogContentText>
                            {t("FOR")} { allcatoption.wpvc_category_amountvotes } {t("buyvotes_category_votes")} { allcatoption.wpvc_category_amountvotesfor } { wpvc_buyvotes_settings.ow_buyvotes_currency }
                        </DialogContentText>
                        }
                        <DialogContentText>
                            {t("buyvotes_total_amount")} { this.state.cost } { wpvc_buyvotes_settings.ow_buyvotes_currency }
                        </DialogContentText>
                        { this.state.cost >= 1 &&
                        <Grid container className="wpvc_form_grid">
                            <FormControl component="fieldset">
                                <FormLabel xs={4} component="legend">
                                    <Typography variant="subtitle2" gutterBottom>
                                        {t('buyvotes_payment_gateway')}
                                    </Typography>
                                </FormLabel>
                                <RadioGroup xs={8} row value={this.state.payment_gateway} onChange={this.updatePaymentGateway} >
                                    {  wpvc_buyvotes_settings.ow_buy_paypal_enable === "on" && 
                                        <FormControlLabel value="paypal" control={<Radio />} label={t('buyvotes_paypal')} /> 
                                    }
                                    {  wpvc_buyvotes_settings.ow_buy_stripe_enable === "on" && wpvc_buyvotes_settings.ow_buy_stripe_publishkey != null && wpvc_buyvotes_settings.ow_buy_stripe_secretkey != null && 
                                        <FormControlLabel value="stripe" control={<Radio />} label={t('buyvotes_stripe')} /> 
                                    }
                                    {  wpvc_buyvotes_settings.ow_buy_paystack_enable === "on" && wpvc_buyvotes_settings.ow_buy_paystack_publickey != null && 
                                        <FormControlLabel value="paystack" control={<Radio />} label={t('buyvotes_paystack')} /> 
                                    }
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        }
                        
                        {
                            wpvc_buyvotes_settings.ow_buy_stripe_enable === 'on' && this.state.payment_gateway == "stripe"  && wpvc_buyvotes_settings.ow_buy_stripe_publishkey != null && wpvc_buyvotes_settings.ow_buy_stripe_secretkey != null && <StripeButton {...this.props} stripePromise={ stripePromise } handleSubmit={this.handleStripeSubmit} />
                        }

                        {
                            wpvc_buyvotes_settings.ow_buy_paypal_enable === 'on' && this.state.payment_gateway == "paypal"  && 
                            <PayPalButton
                                amount={this.state.cost || "1.00"}
                                shippingPreference="NO_SHIPPING" 
                                onSuccess={(details, data) => {
                                    this.setState({open: false});
                                    let payment_details = { 'gateway' : this.state.payment_gateway, 'response' : details, 'cost': this.state.cost, 'vote_count' : this.state.no_of_votes, 'index' : this.props.indexpost, 'settings' : this.props.settings.contest, 'term' : this.props.short.id};
                                    this.props.buyvotesPayment(this.props.SITE_URL, this.props.singlepost.id, payment_details);
                                    // alert('Voted Successfully');
                                    this.setState({
                                        show_popup : true,
                                        popup_title:"voted_sucess",
                                        popup_content:"you_voted",
                                        popbg_color:'#29b664',
                                        popbg_icon:"sucess",
                                        show_index:this.props.indexpost
                                    })
                                    return;
                                }}
                                onError={(err) => {
                                    // alert('error from the onError callback', err);
                                    console.error('error from the onError callback', err);
                                    this.setState({
                                        show_popup : true,
                                        popup_title:"Transaction Failed",
                                        popup_content:err,
                                        popbg_color:'#e67e22',
                                        popbg_icon:"already",
                                        show_index:this.props.indexpost
                                    })
                                }}
                                onCancel={() => {
                                    this.setState({
                                        show_popup : true,
                                        popup_title:"Transaction Cancelled",
                                        popup_content:'You have cancelled the payment.',
                                        popbg_color:'#e67e22',
                                        popbg_icon:"already",
                                        show_index:this.props.indexpost
                                    })
                                }}
                                options={{
                                    clientId : paypalClientID,
                                    currency : wpvc_buyvotes_settings.ow_buyvotes_currency || 'USD'
                                }}
                            />
                        }

                        {
                            wpvc_buyvotes_settings.ow_buy_paystack_enable === 'on' && this.state.payment_gateway == "paystack"  &&  wpvc_buyvotes_settings.ow_buy_paystack_publickey != null && <PaystackButton className="wpvc_payment_btn" {...componentProps} />
                        }
                        
                        <Grid container className="wpvc_form_grid">

                        { allcatoption.wpvc_category_tiered_payment_settings == 'on' && allcatoption.wpvc_category_tiered_payment_show == 'on' &&
                            <TableContainer component={Paper}>
                                <Table className="" aria-label="simple table">
                                    <TableHead>
                                    <TableRow>
                                        <TableCell>{ !this.state.fixed_tiers ? t("buyvotes_amount_per_vote") : t("buyvotes_total_amount")}</TableCell>
                                        <TableCell align="right">{ !this.state.fixed_tiers ? t("buyvotes_category_from") : t("buyvotes_category_votes")}</TableCell>
                                        { !this.state.fixed_tiers &&
                                        <TableCell align="right">{t("buyvotes_category_to")}</TableCell>
                                        }
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {allcatoption.wpvc_category_amountvotes_range.map((row) => (
                                        <TableRow key={row.value}>
                                        <TableCell component="th" scope="row">
                                            { this.state.fixed_tiers ? (row.value * row.from).toFixed(2) : row.value }
                                        </TableCell>
                                        <TableCell align="right">{row.from}</TableCell>
                                        { !this.state.fixed_tiers &&
                                        <TableCell align="right">{row.to}</TableCell>
                                        }
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        }
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Cancel
                    </Button>
                    </DialogActions>
                </Dialog>
                {(this.state.show_popup == 1) && (this.state.show_index == this.props.indexpost) &&
                    <Dialog maxWidth="xs" fullWidth={true} onClose={this.handlemodalclose} aria-labelledby="customized-dialog-title" open={this.state.show_popup}>
                        <MuiDialogTitle className="wpvc_sucess_popup_title" onClose={this.handlemodalclose}>
                            <Typography variant="h6">{t(this.state.popup_title)}</Typography>
                            <IconButton aria-label="close" onClick={this.handlemodalclose}>
                                <CloseIcon  onClick={this.handlemodalclose} />
                            </IconButton>
                        </MuiDialogTitle>

                        <MuiDialogContent dividers className="wpvc_sucess_popup_content" style={{'background':this.state.popbg_color}}>
                            <Typography paragraph="true">
                                {this.state.popbg_icon == "sucess" && 
                                    <CheckIcon />
                                }
                                {this.state.popbg_icon == "already" && 
                                    <WarningIcon />
                                }
                                {t(this.state.popup_content)}
                                
                            </Typography>
                        </MuiDialogContent>

                    </Dialog>
                }

                {this.state.show_recaptcha == 1 &&
                         <Dialog maxWidth="xs"  fullWidth={true} onClose={this.handleCaptchaClose} aria-labelledby="customized-dialog-title" open={this.state.show_recaptcha}>
                         <MuiDialogTitle className="wpvc_sucess_popup_title" onClose={this.handleCaptchaClose}>
                             <Typography variant="h6">{t('captcha_title')}</Typography>
                             <IconButton aria-label="close" onClick={this.handleCaptchaClose}>
                                 <CloseIcon />
                             </IconButton>
                         </MuiDialogTitle>

                         <MuiDialogContent dividers className="wpvc_captcha_popup_content"  style={{'background':this.props.settings.color.votes_button_bgcolor_hover}}>
                            <ReCAPTCHA sitekey={vote_recapatcha_key} onChange={this.onCaptchaClick} />
                         </MuiDialogContent>
                     </Dialog>
                }
            </div>
        )
    }
}

export default (withTranslation()(BuyvotesButton));